import { Fragment, type ReactNode } from 'react';
import { TopSpacer } from '../../components/editorial/PublicationShared';
import {
  CAPITAL_PARTNER_NETWORK_CONTENT,
  CAPITAL_PARTNER_SECTION_ORDER,
  type CapitalPartnerSectionId,
} from './content';
import { PageShell } from './styles';
import ApplicationSection from './sections/ApplicationSection';
import BusinessesSection from './sections/BusinessesSection';
import HeroSection from './sections/HeroSection';
import HowItWorksSection from './sections/HowItWorksSection';
import InvestorBenefitsSection from './sections/InvestorBenefitsSection';
import MarketProblemSection from './sections/MarketProblemSection';
import NetworkDefinitionSection from './sections/NetworkDefinitionSection';
import UniquePositionSection from './sections/UniquePositionSection';
import WhoShouldJoinSection from './sections/WhoShouldJoinSection';
import WhyNowSection from './sections/WhyNowSection';

export default function CapitalPartnerNetworkView() {
  const sectionRenderers: Record<CapitalPartnerSectionId, ReactNode> = {
    hero: <HeroSection copy={CAPITAL_PARTNER_NETWORK_CONTENT.hero} />,
    whyNow: <WhyNowSection copy={CAPITAL_PARTNER_NETWORK_CONTENT.whyNow} />,
    marketProblem: (
      <MarketProblemSection copy={CAPITAL_PARTNER_NETWORK_CONTENT.marketProblem} />
    ),
    uniquePosition: (
      <UniquePositionSection copy={CAPITAL_PARTNER_NETWORK_CONTENT.uniquePosition} />
    ),
    networkDefinition: (
      <NetworkDefinitionSection copy={CAPITAL_PARTNER_NETWORK_CONTENT.networkDefinition} />
    ),
    howItWorks: <HowItWorksSection copy={CAPITAL_PARTNER_NETWORK_CONTENT.howItWorks} />,
    investorBenefits: (
      <InvestorBenefitsSection copy={CAPITAL_PARTNER_NETWORK_CONTENT.investorBenefits} />
    ),
    businesses: <BusinessesSection copy={CAPITAL_PARTNER_NETWORK_CONTENT.businesses} />,
    whoShouldJoin: (
      <WhoShouldJoinSection copy={CAPITAL_PARTNER_NETWORK_CONTENT.whoShouldJoin} />
    ),
    application: <ApplicationSection copy={CAPITAL_PARTNER_NETWORK_CONTENT.application} />,
  };

  return (
    <PageShell>
      <TopSpacer />
      {CAPITAL_PARTNER_SECTION_ORDER.map((sectionId) => (
        <Fragment key={sectionId}>{sectionRenderers[sectionId]}</Fragment>
      ))}
    </PageShell>
  );
}
